import { createTypedSxStyles, capitalDesignTokens } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  mediaBlockTileContainerBase: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  mediaBlockTileContainer: {
    padding: '0px 20px'
  },
  mediaBlockLabel: {
    marginBottom: '30px',
    textAlign: 'center'
  },
  mediaBlockContainer: {
    borderRadius: '4px',
    background: capitalDesignTokens.semanticColors.background.secondary,
    padding: '36px 28px',
    border: `1px dashed ${capitalDesignTokens.semanticColors.border.tertiary}`
  },
  tileCard: {
    minWidth: '80px',
    borderRadius: '4px',
    background: capitalDesignTokens.semanticColors.background.disabled,
    '& .MuiCardContent-root:last-child ': {
      padding: '8px 8px 2px 8px'
    },
    '&:hover': {
      cursor: 'pointer'
    }
  },
  disabledTileCard: {
    minWidth: '80px',
    borderRadius: '4px',
    background: capitalDesignTokens.semanticColors.background.disabled,
    '& .MuiCardContent-root:last-child ': {
      padding: '8px 8px 2px 8px'
    },
    'svg > path': {
      fill: capitalDesignTokens.semanticColors.foreground.disabled
    },
    '&:hover': {
      cursor: 'pointer'
    }
  }
});
